/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchStripePublishableKeyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchStripePublishableKeyQuery = { __typename?: 'Query', stripePublishableKey?: string | null };

export type CreateSessionForOneOffPaymentMutationVariables = Types.Exact<{
  lineItems: Array<Types.StripeSessionLineItemInput> | Types.StripeSessionLineItemInput;
}>;


export type CreateSessionForOneOffPaymentMutation = { __typename?: 'Mutation', createSessionForOneOffPayment?: { __typename?: 'StripeCreateSessionResult', clientSecret: string } | null };


export const FetchStripePublishableKeyDocument = gql`
    query fetchStripePublishableKey {
  stripePublishableKey
}
    `;

/**
 * __useFetchStripePublishableKeyQuery__
 *
 * To run a query within a React component, call `useFetchStripePublishableKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchStripePublishableKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchStripePublishableKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchStripePublishableKeyQuery(baseOptions?: Apollo.QueryHookOptions<FetchStripePublishableKeyQuery, FetchStripePublishableKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchStripePublishableKeyQuery, FetchStripePublishableKeyQueryVariables>(FetchStripePublishableKeyDocument, options);
      }
export function useFetchStripePublishableKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchStripePublishableKeyQuery, FetchStripePublishableKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchStripePublishableKeyQuery, FetchStripePublishableKeyQueryVariables>(FetchStripePublishableKeyDocument, options);
        }
export function useFetchStripePublishableKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchStripePublishableKeyQuery, FetchStripePublishableKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchStripePublishableKeyQuery, FetchStripePublishableKeyQueryVariables>(FetchStripePublishableKeyDocument, options);
        }
export type FetchStripePublishableKeyQueryHookResult = ReturnType<typeof useFetchStripePublishableKeyQuery>;
export type FetchStripePublishableKeyLazyQueryHookResult = ReturnType<typeof useFetchStripePublishableKeyLazyQuery>;
export type FetchStripePublishableKeySuspenseQueryHookResult = ReturnType<typeof useFetchStripePublishableKeySuspenseQuery>;
export type FetchStripePublishableKeyQueryResult = Apollo.QueryResult<FetchStripePublishableKeyQuery, FetchStripePublishableKeyQueryVariables>;
export const CreateSessionForOneOffPaymentDocument = gql`
    mutation createSessionForOneOffPayment($lineItems: [StripeSessionLineItemInput!]!) {
  createSessionForOneOffPayment(lineItems: $lineItems) {
    clientSecret
  }
}
    `;
export type CreateSessionForOneOffPaymentMutationFn = Apollo.MutationFunction<CreateSessionForOneOffPaymentMutation, CreateSessionForOneOffPaymentMutationVariables>;

/**
 * __useCreateSessionForOneOffPaymentMutation__
 *
 * To run a mutation, you first call `useCreateSessionForOneOffPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionForOneOffPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionForOneOffPaymentMutation, { data, loading, error }] = useCreateSessionForOneOffPaymentMutation({
 *   variables: {
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useCreateSessionForOneOffPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionForOneOffPaymentMutation, CreateSessionForOneOffPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionForOneOffPaymentMutation, CreateSessionForOneOffPaymentMutationVariables>(CreateSessionForOneOffPaymentDocument, options);
      }
export type CreateSessionForOneOffPaymentMutationHookResult = ReturnType<typeof useCreateSessionForOneOffPaymentMutation>;
export type CreateSessionForOneOffPaymentMutationResult = Apollo.MutationResult<CreateSessionForOneOffPaymentMutation>;
export type CreateSessionForOneOffPaymentMutationOptions = Apollo.BaseMutationOptions<CreateSessionForOneOffPaymentMutation, CreateSessionForOneOffPaymentMutationVariables>;